import { render } from "./FieldRender.vue?vue&type=template&id=21d96a94&scoped=true"
import script from "./FieldRender.vue?vue&type=script&lang=ts"
export * from "./FieldRender.vue?vue&type=script&lang=ts"

import "./FieldRender.vue?vue&type=style&index=0&id=21d96a94&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-21d96a94"

export default script